import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { createCommodityAction } from "../../../../../modules/commodities/action";
import "../../../../../style";
import { validForm } from "../../../../FormElement/FormValidator";
import CommodityForm from "./CommodityForm";



class CreateCommodity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commodityInfo: {
        name: "",
        lbsPerBushel: ""
      },
      formErrors: {
        name: "",
        lbsPerBushel: ""
      },
      isValid: true,
      successMessage: false,
      errorMessage: {}
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      prevState => {
        return {
          commodityInfo: {
            ...prevState.commodityInfo,
            [name]: value
          }
        };
      },
      () => {
        const { commodityInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, commodityInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.commCreated && nextProps.commCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { commodityInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, commodityInfo)
        });
      }
    );
  };

  createCommodity = e => {
    e.preventDefault();
    const { commodityInfo, isValid } = this.state;
    if (!isValid) {
      this.props.createCommodityAction(commodityInfo);
    }
  };

  render() {
    const { successMessage, isValid, commodityInfo } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/commodities" />;
    }
    return (
      <CommodityForm
        buttonLabel="Add new commodity"
        formLabel="Set up your commodity"
        commodityInfo={commodityInfo}
        handleChange={this.handleChange}
        handleError={this.handleError}
        createCommodity={this.createCommodity}
        isValid={isValid}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    commCreated: state.commodityReducer.commCreated
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createCommodityAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCommodity);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/Commodities/CreateCommodity.js